import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

import { Paragraph } from "@fronterahealth/frontera-ui-components";

import { EhrSyncWarningType } from "@api/graphql/types-and-hooks";

export interface WarningItemProps {
  warning?: EhrSyncWarningType;
}

export const WarningItem: React.FC<WarningItemProps> = ({ warning }) => {
  const [expanded, setExpanded] = useState(false);
  if (!warning) return null;

  return (
    <div className="flex flex-row gap-3">
      <div className="pt-1">
        <button
          type="button"
          className="flex items-center text-blue-600"
          onClick={() => setExpanded((e) => !e)}
          aria-expanded={expanded}
        >
          {expanded ? <ChevronUpIcon className="h-6 w-6" /> : <ChevronDownIcon className="h-6 w-6" />}
        </button>
      </div>
      <div className="flex flex-col flex-1">
        <Paragraph colorType="primary">{warning.description}</Paragraph>
        {expanded && (
          <ul className="max-h-48 overflow-y-auto mt-2">
            {warning.affectedItems.map((it, idx) => (
              <li key={idx} className="list-disc ml-5 text-sm text-gray-700">
                {it?.message}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
